import {
  IntegrationSourceActions,
  IntegrationSourceTitle,
} from '@modules/integrationsV2/components/IntegrationsContainer/IntegrationsSourceDetailView';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { Box, Stack } from '@mui/material';
import { IntegrationViewFragment } from 'generated/graphql';

interface IntegrationSourceToolbarProps {
  integrationSource: IntegrationSource;
  integrations: IntegrationViewFragment[];
}

export const IntegrationSourceToolbar = ({
  integrationSource,
  integrations,
}: IntegrationSourceToolbarProps) => {
  return (
    <Box width="100%">
      <Stack
        direction="row"
        alignItems="flex-start"
        spacing={0.5}
        justifyContent="space-between"
        width="100%"
      >
        <IntegrationSourceTitle
          integrationSource={integrationSource}
          integrations={integrations}
        />
        <IntegrationSourceActions
          integrationSource={integrationSource}
          integrations={integrations}
        />
      </Stack>
    </Box>
  );
};
